export default __webpack_public_path__ + "static/naming-the-action-dark-mode-43ed466143ae65d2bc175b2477157463.png";